import React from "react";
import Marquee from "react-fast-marquee";
import "../styles/marque.css";

export default function MarqueeBaar({ textArray, top = "auto", speed }) {
  return (
    <Marquee pauseOnHover={true} speed={speed} className="h-bar-container">
      {textArray.map((text, index) => (
        <div key={index} className="h-bar" style={{ top: top }}>
          <p>{text}</p>
        </div>
      ))}
    </Marquee>
  );
}
